import { LoaderFunction } from 'react-router-dom';
import { client } from '~/api/client';
import { queryData } from '~/api/data/request';
import { loadQuery } from '~/api/data/responses';
import {
  ExcelSpreadsheetTemplateFieldsFragment,
  GetExcelSpreadsheetTemplateDocument,
  GetExcelSpreadsheetTemplateQuery,
  GetExcelSpreadsheetTemplateQueryVariables,
  GetExcelSpreadsheetTemplatesDocument,
  GetExcelSpreadsheetTemplatesQuery,
  GetExcelSpreadsheetTemplatesQueryVariables
} from '~/api/graphql';

export const getExcelSpreadsheetTemplates = async () =>
  queryData<
    GetExcelSpreadsheetTemplatesQuery,
    GetExcelSpreadsheetTemplatesQueryVariables,
    ExcelSpreadsheetTemplateFieldsFragment[]
  >(
    client,
    { query: GetExcelSpreadsheetTemplatesDocument },
    (data) => data?.excelSpreadsheetTemplates || []
  );

export const getExcelSpreadsheetTemplate = async (id: string) =>
  queryData<
    GetExcelSpreadsheetTemplateQuery,
    GetExcelSpreadsheetTemplateQueryVariables,
    ExcelSpreadsheetTemplateFieldsFragment
  >(
    client,
    { query: GetExcelSpreadsheetTemplateDocument, variables: { id: id } },
    (data) => data?.excelSpreadsheetTemplate
  );

export const loadExcelSpreadsheetTemplates: LoaderFunction = () =>
  loadQuery(getExcelSpreadsheetTemplates(), { suppressAuthErrors: true });

export const loadExcelSpreadsheetTemplate: LoaderFunction = ({ params }) =>
  loadQuery(getExcelSpreadsheetTemplate(params.id || ''));
